module.exports = __webpack_public_path__ + "images/centaur_small57c8cff7f196c34f77df19ac2c5c0306.png";